// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationBar_pagination__j6qoM","publicPagination":"PaginationBar_publicPagination__Sc3jp"};